<template>
  <div :class="device.desktop ? `home pa-6 grey lighten-4`:`home pa-0 grey lighten-4`">

    <v-row>
      <v-col cols="12">
        <v-card class="animated animate__fadeInUp rounded-0">
          <v-card-title :class="`flex flex-row-reverse ` + theme.color + ` lighten-1`">
            <div class="white pb-1 pl-5 pr-5 rounded-pill">
              <v-tooltip
                :color="theme.color"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    small
                    icon
                    v-on="on"
                    :color="theme.color"
                    v-show="page.actions.add"
                    class="animate__animated animate__heartBeat animate__delay-1s"
                  >
                    <v-icon
                      color="blue"
                      @click="openForm"
                    >mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Tambah Data</span>
              </v-tooltip>
              <v-tooltip
                :color="theme.color"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    small
                    icon
                    v-on="on"
                    :color="theme.color"
                  >
                    <v-icon
                      color="green"
                      @click="fetchRecords"
                    >mdi-refresh-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh Data</span>
              </v-tooltip>
            </div>

            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pencarian"
              single-line
              hide-details
              solo
              dense
              rounded
              :color="theme.color"
              style="max-width: 350px"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-show="device.desktop"
            :headers="headers"
            :items="records"
            :items-per-page="table.options.itemsPerPage"
            :page.sync="table.options.page"
            class="elevation-2 mb-1"
            :color="theme.color"
            :loading="loading.table"
            loading-text="Loading... Please wait"
            :search="search"
            hide-default-footer
            @page-count="table.options.pageCount = $event"
            show-select
          >
            <v-progress-linear
              slot="progress"
              :color="theme.color"
              height="1"
              indeterminate
            ></v-progress-linear>
            <template v-slot:item.progress="{ value }">
              <v-progress-linear
                :color="theme.color"
                v-model="value"
                height="25"
              >
                <strong>{{ value }}%</strong>
              </v-progress-linear>
            </template>

            <template v-slot:item.status="{ value }">
              <v-chip
                :color="value.color"
                small
              >{{ value.text }}</v-chip>
            </template>
            <template v-slot:item.aksi="{ value }">
              <v-menu
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    :color="theme.color"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-dots-vertical-circle-outline
                  </v-icon>
                </template>

                <v-list>
                  <v-list-item @click="openSubCategory(value)">
                    <v-list-item-title>
                      <v-icon
                        class="mr-1"
                        :color="theme.color"
                      >mdi-widgets</v-icon>Manajemen Sub Kategori
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    @click="editRecord(value.id)"
                    v-show="page.actions.edit"
                  >
                    <v-list-item-title>
                      <v-icon
                        class="mr-1"
                        color="orange"
                      >mdi-pencil-circle</v-icon>Ubah
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="postDeleteRecord(value.id)"
                    v-show="page.actions.delete"
                  >
                    <v-list-item-title>
                      <v-icon
                        class="mr-1"
                        color="red"
                      >mdi-delete-circle</v-icon>Hapus
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
          <v-list
            subheader
            v-show="device.mobile"
          >

            <v-list-item-group
              multiple
              active-class=""
            >
              <v-list-item
                v-for="item in filterItems"
                :key="item.id"
                style="border: ;1px solid"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.description }} </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-menu
                      bottom
                      origin="center center"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          :color="theme.color"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-dots-vertical-circle-outline
                        </v-icon>
                      </template>

                      <v-list>

                        <v-divider v-if="page.delete || page.edit"></v-divider>
                        <v-list-item
                          @click="editRecord(item.id)"
                          v-show="page.actions.edit"
                        >
                          <v-list-item-title>
                            <v-icon color="orange">mdi-pencil-circle</v-icon>
                            Ubah Data
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="postDeleteRecord(item.uuid)"
                          v-show="page.actions.delete"
                        >
                          <v-list-item-title>
                            <v-icon color="red">mdi-delete-circle</v-icon>
                            Hapus Data
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="form.add"
        :max-width="device.desktop ? `600px` : `100%`"
        persistent
        :fullscreen="device.mobile"
      >
        <v-card>
          <v-toolbar
            :color="theme.color"
            :dark="theme.mode"
            class="rounded-b-xl animate__animated animate__fadeInDown"
            flat
          >
            <div class="rounded-pill white pb-1 pr-5 pt-1">
              <v-icon
                color="blue"
                class="ml-1  mr-1  "
              >mdi-circle</v-icon> <span class="blue--text">
                Formulir Master Kategori
              </span>

            </div>
          </v-toolbar>
          <v-card-text class="mt-5">
            <v-col cols="12">
              <v-text-field
                label="Kategori"
                placeholde=""
                outlined
                dense
                hide-details
                v-model="record.name"
                :color="theme.color"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Keterangan"
                outlined
                dense
                hide-details
                v-model="record.description"
                :color="theme.color"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Icon (MDI Icon)"
                placeholde="mdi-home"
                outlined
                dense
                hide-details
                v-model="record.icon"
                :color="theme.color"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-switch
                label="Status"
                outlined
                dense
                hide-detail
                v-model="record.status"
                :color="theme.color"
              ></v-switch>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="justify-end animate__animated animate__fadeIn animate__delay-1s">
            <v-btn
              outlined
              :color="theme.color"
              v-show="!form.edit"
              @click="postAddNewRecord"
              class="text-transform-none"
              rounded
            ><v-icon small>mdi-content-save</v-icon> Tambah</v-btn>
            <v-btn
              outlined
              :color="theme.color"
              v-show="form.edit"
              @click="postUpdateRecord"
              rounded
              class="text-transform-none"
            >Ubah</v-btn>
            <v-btn
              outlined
              color="red"
              @click="closeForm"
              class="text-transform-none"
              rounded
            > <v-icon small>mdi-close-circle</v-icon>Batal</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </div>
</template>
            <script>
import { mapActions, mapState } from "vuex";
import "animate.css";

export default {
  name: "master-category",
  data: () => ({
    num: 1,
    headers: [
      {
        text: "KATEGORI",
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: "KETERANGAN",
        align: "start",
        sortable: true,
        value: "description",
      },
      {
        text: "STATUS",
        align: "center",
        sortable: false,
        value: "status",
        width: 159,
      },
      {
        text: "AKSI",
        value: "aksi",
        width: 100,
        sortable: false,
        align: "center",
      },
    ],
    search: null,
    filename: null,
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "event",
      "snackbar",
      "table",
      "form",
    ]),
    filterItems() {
      if (this.search != null) {
        return this.records.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else {
        return this.records;
      }
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/v2/master-data/category",
      pagination: false,
      key: "id",
      title: "MASTER KATEGORI ",
      subtitle: "Berikut Daftar Seluruh Kategori Yang Tersedia",
      breadcrumbs: [
        {
          text: "Master",
          disabled: true,
          href: "",
        },
        {
          text: "Kategori",
          disabled: true,
          href: "",
        },
      ],
      showtable: true,
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
        bulkdelete: false,
        print: false,
        export: false,
        help: false,
      },
    });
    this.fetchRecords();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postAddNew",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "assignFileBrowse",
      "setLoading",
      "setRecord",
      "setForm",
    ]),
    openForm: function () {
      this.setForm({
        add: true,
        edit: false,
      });
      this.setRecord({});
    },
    closeForm: function () {
      this.setForm({
        add: false,
        edit: false,
      });
    },
    postAddNewRecord: function () {
      this.postAddNew(this.record).then(() => {
        this.closeForm();
      });
    },
    editRecord: function (val) {
      this.postEdit(val).then(() => {
        this.filename = this.record.icon;
      });
      this.setForm({
        add: true,
        edit: true,
      });
    },
    postUpdateRecord: function () {
      this.postUpdate(this.record).then(() => {
        this.closeForm();
      });
    },
    postDeleteRecord: function (val) {
      this.postConfirmDelete(val);
    },
    postDownload(val) {
      window.open(val, "__blank");
    },
    uploadFile: function () {
      this.assignFileBrowse({
        fileType: [".png", ".jpg", ".jpeg"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          setTimeout(() => {
            this.filename = response.name;
            this.record.icon = response.name;
          }, 500);
        },
      });
    },
    openSubCategory: function (val) {
      this.$router.push({
        name: "master-data-sub-category",
        params: {
          category_uuid: val.id,
          category_name: val.name,
        },
      });
    },
  },
};
</script>